<template>
  <button id="NUMBER_3" name="3" class="btn num-btn" data-vcode="NUMBER_3" aria-label="3 DEF">
    <div class="digit">3</div>
    <div class="letters">DEF</div>
  </button>
</template>
<script>
export default {};
</script>
